// extracted by mini-css-extract-plugin
module.exports = {"button":"d4f263","button_small":"e73b38","button_secondary":"b5bbb5","button_success":"_26ed1b","button_error":"_65ade5","button__loader":"_0bee34","button__loader-icon":"_8a5d14"};